import axios from 'axios'

import { baseURL } from '../util/values'

export function fetchUser(pk) {
	return axios
		.get('/api/v1/user/' + pk + '/?format=json')
		.then(response => {
			return response.data
		})
		.catch(error => {
			return error
		})
}

export function fetchUserUuid(uuid) {
	return axios
		.get('/api/v1/user-uuid/' + uuid + '/?format=json')
		.then((response) => {
			return response.data
		})
		.catch((error) => {
			return error
		})
}

export function fetchUserLocation(ip) {
	return axios
		.get('https://api.ipgeolocation.io/ipgeo?apiKey=ab625822cfe34ef99abfd8593d4eb12e')
		.then(response => {
			return response.data
		})
		.catch(error => {
			return error
		})
}

export function putUserProp(pk, payload) {
	console.log(payload)
	axios
		.put('/api/v1/user/' + pk + '/', payload)
		.then(response => {
			console.log(response.data)
		})
		.catch(error => {
			console.error(error)
		})
}
